import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { Subscription, finalize } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PubSubEvent, PubSubService } from 'src/app/services/util/pub-sub.service';
import { AppMainComponent } from '../../app.main.component';
import { MenuItem } from 'primeng/api';
import { SingUrlPipe } from '../../../shared/pipes/sign-url.pipe';
import { NgClass, AsyncPipe } from '@angular/common';
import { AlertService } from 'src/app/services/util/alert.service';
import { DialogService } from 'primeng/dynamicdialog';
import { AlterarSenhaDialogComponent } from './alterar-senha.component';

interface INotifications extends MenuItem {
  route: string;
}

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
    standalone: true,
    imports: [
    NgClass,
    AsyncPipe,
    SingUrlPipe
],
})
export class AppTopBarComponent implements OnInit, OnDestroy {
  usuario: string = '';
  foto: string = '';
  loading: boolean = false;
  eventSubscription: Subscription | undefined;
  notifications: INotifications[] | undefined;
  totalNotifications: number = 0;

  intervalNotifications: any;

  constructor(
    public app: AppComponent,
    public appMain: AppMainComponent,
    private authService: AuthService,
    private router: Router,
    private pubSubService: PubSubService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private dialog: DialogService
  ) {}

  ngOnInit() {
    this.getUserInfo();
  }

  ngOnDestroy() {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }

    if (this.intervalNotifications) {
      clearInterval(this.intervalNotifications);
    }
  }

  logout() {
    this.authService.removeSession();
  }

  navigate(param: string) {
    this.router.navigate([param]);
  }

  getUserInfo() {
    this.eventSubscription = this.pubSubService.getEvent().subscribe((event: PubSubEvent) => {
      if (event === 'ATUALIZAR_USUARIO_LOGADO') {
        this.usuario = this.authService.getUser()?.nome ?? 'Usuário';
        this.foto = this.authService.getUser()?.foto ?? '';
      }
    });
  }

  changePassword() {
    const usuario = this.authService.getUser();
    this.router.navigate(['usuario', 'retaguarda', 'senha', usuario?.nanoid]);
  }

  alterarSenha() {
  this.dialog
    .open(AlterarSenhaDialogComponent, {
      header: 'Alterar senha',
      width: '450px',
      dismissableMask: true,
    })
    .onClose.subscribe((ok: boolean) => {
      if (ok) {
        // opcional: encerre a sessão e direcione ao login
        this.logout();
        this.router.navigate(['/login']);
      }
    });
}
}